module.exports = __webpack_public_path__ + "static/media/Roboto_regular.43ca631e.woff";